import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateApplicationService } from 'src/app/core/translate/translate-application-service';

@Component({
	selector: 'app-without-permission',
	templateUrl: './without-permission.component.html',
	styleUrls: ['without-permission.component.scss'],
})
export class WithoutPermissionComponent implements OnInit {
	constructor(
		public router: Router,
		public translate: TranslateApplicationService
	) {}

	ngOnInit(): void {
		// This is intentional
	}
}
